import SearchPatientTableHeader from 'shared_components/search_pager';

export default SearchPatientTableHeader;